module.exports = __webpack_public_path__ + "img/tile_03.e4a0c99a.jpg";